import React, { useState } from "react";
import { v4 as uuidv4 } from 'uuid';
import styled from 'styled-components';
import { Link, navigate } from "gatsby"
import LangSwitcher from "./LangSwitcher";
import {Button} from "../../global/Button";
import { StoryTitleWave } from "./StoryTitleWave";
import { FavHeart } from "./FavHeart";
import { Tag } from "./Tag";
import TagSlider from "./TagSlider";
import Seo from "../../global/Seo";
import Text from '../../global/typo/Text'
import StoryTitleBig from "../../global/typo/StoryTitleBig";
import StoryMetaBig from  './StoryMetaBig'
import MoreLikeThis from "./moreLikeThis";
import { useTranslation } from 'react-i18next'
import spiciness1 from "./assets/spiciness-1.png";
import spiciness2 from "./assets/spiciness-2.png";
import spiciness3 from "./assets/spiciness-3.png";
import playFilled from "./assets/play-filled.svg";
import lock from "./assets/lock.svg";
import usePublicAudioContext from "../../context/AudioPlayerContext";
import Navigation from './navigation'
import CoverImage from './CoverImage'

const SingleContentPage = (props) => {
  const { title, coverImage600, coverImage450, metaLinks, spiciness, tags, seoTitle, seoDescription, duration, seoSummary, audiodesiresOriginal, voices, lovenseSync, coverAlt, label, labelLink ,similarStories, seriesStories, sameScenarioStories, audioUrl, type, languages} = props
  const [showMoreText, setShowMoreText] = useState(false);
  const { setCurrentTrack } = usePublicAudioContext()
  const { t } = useTranslation()
  const filteredVoices = voices.filter(voice => voice.slug !== "placeholder")
  const handleFullPlayClick = () => navigate(t('urls.register'))
  const handlePlay = () => {
    setCurrentTrack({url:audioUrl, title, voices, cover:coverImage450})
  }
  
  return (
    <OuterWrapper>
      <Seo description={seoDescription} title={seoTitle} image={coverImage600} languages={languages}/>
      <Navigation type={type}/>
      <HeartWrapper onClick={() => navigate(t('urls.register'))} ><FavHeart/> </HeartWrapper>
      <StoryDetailWrapper >
        <CoverImage coverImage={coverImage600} mobileCoverImage={coverImage450} coverAlt={coverAlt} title={title} />
        <StoryTitleWave >
          <ContentType><Link to={labelLink}>{label}</Link></ContentType>
          <StoryTitleBig>{title}</StoryTitleBig>
            <StoryMetaBig>
              <MetaLink to={`${metaLinks[0].link}`}> {metaLinks[0].label}</MetaLink> •
              <MetaLink to={`${metaLinks[1].link}`}> {metaLinks[1].label}</MetaLink>{metaLinks[2] && " •"}
              {metaLinks[2] && <MetaLink to={`${metaLinks[2].link}`}> {metaLinks[2].label}</MetaLink>}
            </StoryMetaBig>
        </StoryTitleWave>
      </StoryDetailWrapper>
      <StoryDetailWrapper>
        <StoryDetailContentWrapper>
          <TagSlider tags={tags} />
          <SummaryWrapper $showMoreText={showMoreText}>
            <Summary $showMoreText={showMoreText} lovenseSync={lovenseSync} dangerouslySetInnerHTML={{ __html: seoSummary }}/>
            <ReadMoreToggle $showMoreText={showMoreText} onClick={()=> setShowMoreText(!showMoreText)}>
              {showMoreText ? t('singleStory.readLess') : t('singleStory.readMore') }
            </ReadMoreToggle>
          </SummaryWrapper>
          <SpicyDurationWrapper>
            <HowSpicyWrapper>
              <p>{t('singleStory.howSpicy')}</p>
              {spiciness === "1" && <MetaLink to={t('urls.erotic-audio-stories')}><Spiciness src={spiciness1}/> </MetaLink>}
              {spiciness === "2" && <MetaLink to={t('urls.audio-sex-stories')}><Spiciness src ={spiciness2}/> </MetaLink>}
              {spiciness === "3" && <MetaLink to={t('urls.audio-porn-stories')}><Spiciness src ={spiciness3}/> </MetaLink>}
            </HowSpicyWrapper>
            <div>
              <Text>{`${parseInt(parseInt(duration)/60)} MINS`}</Text>
            </div>
          </SpicyDurationWrapper>
          <VoicesWrapper>
            {filteredVoices.length > 0 && 
              <>
                <Text mr="20px">Voices:</Text>
                {filteredVoices.map((voice) => (
                  <Link to={`${type === "community" ? "/community" :""}${t('urls.voice')}${voice.slug}/`} key={uuidv4()}> <Tag>{voice.name}</Tag></Link>
                ))}
              </>
            }
          </VoicesWrapper>
          {languages.length > 1 && 
            <LanguageWrapper>
              <LangText>{t('singleStory.language')}</LangText>
              <LangSwitcher $border $small $smallBorder/>
            </LanguageWrapper>
          }
          
          <Button $marginTop  $block onClick={handleFullPlayClick}>
            <ButtonIconWrapper>
              <ButtonIcon src={lock}/>
              <p>{t('singleStory.unlockButton')}</p>
            </ButtonIconWrapper>
          </Button>
          <Button $marginTop $inverted $border $block onClick={handlePlay}>
            <ButtonIconWrapper>
              <ButtonIcon src={playFilled}/>
              <p>{t('singleStory.playSampleButton')}</p>
            </ButtonIconWrapper>
          </Button>
          <MoreLikeThis 
            similarStories={similarStories} 
            seriesStories={seriesStories}
            sameScenarioStories={sameScenarioStories}
            audiodesiresOriginal={audiodesiresOriginal}
          />
        </StoryDetailContentWrapper>
      </StoryDetailWrapper>
    </OuterWrapper>
  )
}




export default SingleContentPage;


const OuterWrapper = styled.div`
  position:relative;
  max-width: 600px;
  margin: 0 auto;
  box-shadow:rgba(0, 0, 0, 0.27) 13px 23px 62px -6px;
`;

/* const CoverImage = styled.img`
  max-width: 100%;
  display: block;
  height:100vw;
  @media (min-width: 600px) {
    height:600px
  }
`; */

const StoryDetailWrapper = styled.div`
  position: relative;
  background-color:${props => props.theme.backgroundColor};
`;


const StoryDetailContentWrapper = styled.div`
  padding: 0px 20px 20px 20px;
  overflow:hidden ;
  h2{
    font-size:30px;
    font-weight:700px;
  }
`

const Spiciness = styled.img`
  width:78px;
  height:30px;
  margin-left: 20px;
`

const HowSpicyWrapper = styled.div`
  display:flex;
  align-items: center;
`

const ButtonIcon  = styled.img`
  height:20px;
  padding-right:10px;
  .st0{fill:#a2e61c;}
`

const ButtonIconWrapper = styled.div`
  z-index:20;
  display:flex;
  align-items: center;
  height: 25px;
  justify-content: center;
  a{
    text-transform:uppercase;
  }
`

const HeartWrapper = styled.div`
  top: 30px;
  position: absolute;
  z-index: 5;
  right: 30px;
  @media (min-width: 600px) {
    right:auto;
    top:auto;
    margin-top: 30px;
    margin-left: 540px;
    z-index: 15;
    position: absolute;
    height: 30px;
    width: 30px;
  }
`

const SpicyDurationWrapper = styled.div`
  display:flex;
  justify-content: space-between;
`

const MetaLink = styled(Link)`
  text-decoration:none;
`

const LanguageWrapper = styled.div`
  display:flex;
  align-items: baseline;
  justify-content: start;
`

const LangText = styled.p`
  padding-right:20px;
`

const ContentType = styled.span`
  font-size:12px;
  margin: 0px 0px;
  text-transform:uppercase;
  > a {
    text-decoration: none;
  }
  font-family: 'Poppins';
  border-bottom:2px solid #F19D9A;
  @media (min-width: 500px) {
    font-size:16px;
  }
`

const VoicesWrapper = styled.div`
  display:flex;
  align-items: center;
  & > a {
    text-decoration:none;
  }
`

const ReadMoreToggle = styled.p`
  background:${props => props.theme.backgroundColor};
  position:absolute;
  bottom: 0;
  line-height:20px;
  right:0;
  padding:0;
  margin:0;
  font-weight:300;
  font-size:14px;
  text-transform:uppercase;
  text-decoration: underline;
  &:before {
    content: "";
    z-index:5;
    text-align: right;
    position: absolute;
    bottom: ${props => props.$showMoreText ? '-100%' : 0};
    left: -100%;
    width: 100%;
    height: 26px;
    background: linear-gradient(to right, rgba(255, 255, 255, 0), ${props => props.theme.backgroundColor} 85%);
  }
`;


const SummaryWrapper = styled.div`
  position:relative;
  padding:0;
  ${props => props.$showMoreText &&" padding-bottom:30px"};
  transition: all 0.2s ease;
  margin:0;
  overflow:hidden;
  height:100% ;
`;

const Summary = styled.p`
  height:${props => props.$showMoreText ? '100%' : `${props.lovenseSync ? '100px' : '78px' }`};
  padding:0;
  margin:0;
  line-height:26px;
  >strong:first-child{
    display:block;
  }
`
